module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-8-81566d2b1091f3e56d0b101ae2684162.svg";